/*
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Webiste: https://jixiaoyong.github.io
 * @Date: 24/05/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/utils/util.js
 * @Description:
 *
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved.
 */
function getVersion(str) {
  let match = str.match(/\d{3}(?=\D|$)/);

  if (!match) {
    console.error("输入的字符串不符合条件：" + str);
    return "v0.0.0";
  }

  console.log(match[0]);

  // 计算 major, minor, patch 版本号
  let parts = match[0];
  let major = parts[0] || 0;
  let minor = parts[1] || 0;
  let patch = parts[2] || 0;

  return "v" + major + "." + minor + "." + patch;
}

/**
 * Compares two version strings and returns -1, 0, or 1 depending on whether version1 is less than, equal to, or greater than version2.
 *
 * @param {string} urlFirst - The first version string.
 * @param {string} urlSecond - The second version string.
 * @returns {number} - -1 if version1 is less than version2, 0 if they are equal, and 1 if version1 is greater than version2.
 *
 * @example
 * compareVersion('https://example.com/app-v123.apk', 'https://example.com/app-v122.apk') // returns 1
 * compareVersion('https://example.com/app-v123.apk', 'https://example.com/app-v123.apk') // returns 0
 * compareVersion('https://example.com/app-v121.apk', 'https://example.com/app-v122.apk') // returns -1
 */
function compareVersion(urlFirst, urlSecond) {
  let firstVersion = getVersion(urlFirst).slice(1).split(".");
  let secondVersion = getVersion(urlSecond).slice(1).split(".");

  for (let i = 0; i < 3; i++) {
    const num1 = parseInt(firstVersion[i], 10);
    const num2 = parseInt(secondVersion[i], 10);

    if (num1 > num2) {
      return 1; // version1 > version2
    }
    if (num1 < num2) {
      return -1; // version1 < version2
    }
  }

  return 0;
}

function findNameByLink(dataList, link) {
  // 从链接中提取关键字段
  const def_name = "未知名字";
  const keyFieldRegex = /app\/app\/(.*?)_[Vv]?\d+/;
  const match = link.match(keyFieldRegex);
  if (!match) {
    console.error("链接不包含有效的关键字段");
    return def_name;
  }
  const keyField = match[1];

  // 遍历数据列表，寻找匹配的名字
  for (const item of dataList) {
    if (item.link && item.link.match(keyFieldRegex)[1] == keyField) {
      return item.name || def_name;
    }
  }

  return def_name;
}

function checkUrlValid(url) {
  if (!url) {
    return false;
  }
  if (url.includes(" ")) {
    return false;
  }

  if (/[^a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]/.test(url)) {
    return false;
  }

  // 正则表达式检测 URL 是否以 http://或 https://开头，以.apk 结尾（不区分大小写）
  const regex = /^(https?:\/\/).+(\.apk)$/i;
  return regex.test(url);
}

export { checkUrlValid, compareVersion, findNameByLink, getVersion };
